__turbopack_context__.v({
  "badge": "Compliances-module-scss-module__n-8EgG__badge",
});
